// @ts-ignore: correct import https://www.npmjs.com/package/jose https://www.npmjs.com/package/jose-browser-runtime
import compactDecrypt from 'jose-browser-runtime/dist/browser/jwe/compact/decrypt'
import { useDokumententresorEncryptionConfig } from '.'
import { Check, CheckResult } from '../api'

export const useDokumententresorEnd2End = (): Check => {
    const encryptionConfig = useDokumententresorEncryptionConfig()

    return {
        id: 'dokumententresor_end2end',
        name: 'Ende-zu-Ende-Verschlüsselung',
        description: 'Testet den kompletten verschlüsselten Download eines Dokuments vom Backend.',
        func: () => {
            return new Promise<CheckResult>((resolve) => {
                const run = async () => {
                    try {
                        const expectedContent = `123456789!"§$%&/()=?` //test.txt in service resources folder

                        const keys = await crypto.subtle.generateKey(encryptionConfig, true, ['encrypt', 'decrypt'])
                        if (!keys || !keys.publicKey) throw Error('Öffentlicher Schlüssel konnte nicht erzeugt werden.')

                        const oeffentlicherNutzerSchluessel = await crypto.subtle.exportKey('jwk', keys.publicKey)
                        const postResponse = await fetch('/api/browsercheck/dokumente', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({ oeffentlicherNutzerSchluessel, schluesselUuid: 'test-uuid' }),
                        })

                        if (postResponse.status !== 200) throw Error(`Anfrage des Dokuments fehlgeschlagen: ${postResponse.statusText}`)

                        const responseJson = await postResponse.json()
                        const decryptionResult = await compactDecrypt(responseJson.jwe, keys.privateKey)
                        const decryptedContent = new TextDecoder().decode(decryptionResult.plaintext)
                        if (decryptedContent !== expectedContent) throw new Error('Die Entschlüsselung war nicht erfolgreich.')

                        return resolve({ status: 'success' })
                    } catch (e) {
                        return resolve({ status: 'error', msg: (e as { message: string }).message })
                    }
                }
                run()
            })
        },
    }
}
